import { ELEMENT_TYPE } from "./constants";
// 把自定义元素转成html元素
/**
 * @param elem 元素的数据结构，如上文的 Resume
 * @param childrenHtml 子节点的 HTML 代码
 * @returns 元素的 HTML 字符串
 */
const elemToHtml = (elem, childrenHtml) => {
  const qContent = JSON.stringify(elem.children[0]);
  const aContent = JSON.stringify(elem.children[1]);
  // 生成 HTML 代码，data-w-e-type用于标记元素类型，后面会用
  const html = `<div data-w-e-type="${ELEMENT_TYPE}" data-qContent='${qContent}' data-aContent='${aContent}'>
    <div style="width: 346px; min-height: 77px; display: block;">
        <div style="width: 100%; min-height: 26px;">
            <span style="float:left; width: 26px; height: 26px; line-height: 26px; display: inline-block; border-radius: 8px; border: 1.3px solid rgb(242, 243, 245); text-align: center; font-weight: 600; background: rgb(255, 255, 255); font-size: 14px; color: rgb(78, 89, 105);">问</span>
            <div style="width:85%; min-height: 26px; line-height: 26px; display: inline-block; margin: 0px 5px;">
                <div>
                    <span data-slate-node="text">
                        <span data-slate-leaf="true">
                            <span class="custom-qa-cont" data-slate-string="true" data-custom-qa-block="qContent">${qContent}</span>
                        </span>
                    </span>
                </div>
            </div>
        </div>
        <div style="width: 100%; min-height: 26px; margin-top: 8px;">
            <span style="float:left; width: 26px; height: 26px; line-height: 26px; display: inline-block; border-radius: 8px; border: 1.3px solid rgb(242, 243, 245); background: rgb(255, 255, 255); text-align: center; font-weight: 600; font-size: 14px; color: rgb(0, 200, 157);">答</span>
            <div style="width:85%; min-height: 26px; line-height: 26px; display: inline-block; margin: 0px 5px;">
                <div>
                    <span>
                        <span>
                            <span class="custom-qa-cont" data-custom-qa-block="aContent">${aContent}</span>
                        </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>`;
  return html;
};

// 编辑器输出html配置
export const elemToHtmlConfig = {
  type: ELEMENT_TYPE,
  elemToHtml: elemToHtml,
};
